import { useState, useEffect, useRef } from 'react';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../Styles/Colors';
import { CommonPatientDetails, ConfirmPopup } from '../../../../Components/Common Components/CommonComponents';
import {
    Box, Button, TextField, Typography, Dialog, DialogTitle, DialogContent,
    DialogActions, Divider, ListItem, ListItemText, Paper, Autocomplete
} from '@mui/material';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import Loader from '../../../../Components/Loader';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import { withTranslation } from 'react-i18next';
import { ContentInTooltip } from '../../../../Components/CommonFunctions/CommonFunctions';
import { ToolsFieldWithMic } from '../../../../Components/Common Components/CommonComponents';

const DocCustomCertificate = (props) => {
    const toolsRef = useRef(null);
    const [state, setState] = useState({
        patientDetails: {},
        disableInputs: false,
        // editor states
        certificateTxt: "",
        renameTxt: "",
        // template states
        edittempName: false,
        selectTemplate: null,
        templateList: [],
        isTempAdd: false,
        addLayoutName: '',
        selectedName: "",
        selectedID: null,
        deleteTemp: false,
        selecDelID: null,
        triggerTemplateValidation: false,

        // message state 
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: '',
        isLoader: false,
    });

    useEffect(() => {
        const patientDetails = JSON.parse(getCachevalue('DoctorPatientData'));
        updateState({ patientDetails });
        getCertificateTxt();
        getTempData()
    }, [])

    const updateState = (data) => {
        setState((prevState) => ({
            ...prevState,
            ...data
        }));
    }

    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message,
            disableBtn: false
        })
    }

    const successMessage = (message) => {
        updateState({
            successMsg: true,
            successMsgText: message,
            disableBtn: false
        })
    }

    const LoaderFunction = (value) => {
        updateState({
            isLoader: value
        })
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const getCertificateTxt = () => {
        try {
            const clinic_id = localGetItem("SelectedDoctorClinicId")
            const patientDetails = JSON.parse(getCachevalue('DoctorPatientData'));
            RestAPIService.getAll(`${Serviceurls.CUSTOM_CERTIFICATE_GET}?clinic_id=${clinic_id}&appointment_id=${patientDetails?.appointment_id}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const certificateDescription = response?.data?.data?.description || response?.data?.description || "";
                        setState((prevState) => ({
                            ...prevState,
                            certificateTxt: certificateDescription
                        }));
                    }
                })
                .catch((e) => {
                    errorMessage(e.response?.data?.message || e.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getTempData = () => {
        try {
            const clinic_id = localGetItem("SelectedDoctorClinicId")

            RestAPIService.getAll(`${Serviceurls.CUSTOM_CERTIFICATE_TEMPLATE}?clinic_id=${clinic_id}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        updateState({
                            templateList: response?.data?.data || [],
                        });
                    }
                })
                .catch((e) => {
                    errorMessage(e.response?.data?.message || e.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const deleteTempData = () => {
        try {
            RestAPIService.delete(`${Serviceurls.CUSTOM_CERTIFICATE_TEMPLATE}?id=${state.selecDelID}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        getTempData()
                        updateState({
                            deleteTemp: false,
                            selecDelID: null,
                            selectTemplate: null,
                            edittempName: false,
                            selectedName: ''
                        })
                        successMessage(response.data.message)
                    }
                })
                .catch((e) => {
                    errorMessage(e.response?.data?.message || e.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const addTempLayout = () => {
        const clinic_id = localGetItem("SelectedDoctorClinicId")
        try {
            let data = {
                "template_name": state?.addLayoutName?.trim() || '',
                "description": state.selectedID ? state?.renameTxt || "" : state?.certificateTxt || '',
                "clinic_id": clinic_id
            }
            if (state.selectedID) {
                data['id'] = state.selectedID
            }

            RestAPIService.create(data, Serviceurls.CUSTOM_CERTIFICATE_TEMPLATE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        getTempData()
                        updateState({
                            addLayoutName: '',
                            isTempAdd: false,
                            selectedID: null,
                            selectTemplate: null,
                            edittempName: false,
                            selectedName: '',
                            renameTxt: '',
                        })
                        successMessage(response.data.message)
                    }
                })
                .catch((e) => {
                    errorMessage(e.response?.data?.message || e.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const handlePrint = () => {
        try {
            RestAPIService.getAll(`${Serviceurls.CUSTOM_CERTIFICATE_GET}?patient_id=${state.patientDetails?.patient_id}&appointment_id=${state?.patientDetails?.appointment_id || null}&export_type=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    updateState({ disableBtn: false })
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message);
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const popClose = () => {
        updateState({
            deleteTemp: false,
            selecDelID: null
        })
    }

    const renderLayAdd = () => {
        const { t } = props
        return (
            <Dialog open={state.isTempAdd} >
                <DialogTitle className='eMed_CreditPoP_TitleDiv' sx={{ borderColor: Colors.themeDark, marginRight: "0vw" }}>
                    <Typography marginLeft={"1vw"}>{t("Add Template Name")}</Typography>
                    <Button onClick={() => { updateState({ isTempAdd: false, addLayoutName: '', selectedID: null }) }} >
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </DialogTitle>
                <DialogContent sx={{ padding: "2vw" }}>
                    <TextField
                        inputProps={{ maxLength: 30 }}
                        sx={{ width: "20vw", marginTop: "2vw" }}
                        size='small'
                        label={t("Template Name")}
                        value={state.addLayoutName}
                        onChange={(event) => {
                            const { value } = event.target;
                            let alphanum = CommonValidation.alphanumValidation(value);
                            if (alphanum || value === '') {
                                updateState({
                                    addLayoutName: value
                                })
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' size='small' className='eMed_Filter_Btns' onClick={() => { updateState({ addLayoutName: '' }) }}>{t("Clear")}</Button>
                    <Button variant='contained' size='small' className='eMed_Filter_Btns' onClick={() => {
                        if (state.addLayoutName !== '') {
                            addTempLayout()
                        } else {
                            errorMessage(t('Please add the template name'));
                        }
                    }}>{state.selectedID ? t("Rename") : t("Add")}</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const TemplateActionButton = ({ label, onClick }) => (
        <Button
            color="primary"
            fullWidth
            sx={{ justifyContent: 'flex-start', pl: 2, textTransform: 'capitalize' }}
            onMouseDown={(e) => {
                e.preventDefault();
                onClick();
            }}
        >
            {label}
        </Button>
    );

    const renderTemplateDropdown = () => {
        return (
            <Autocomplete
                clearIcon
                size="small"
                disabled={state.disableInputs}
                sx={{ width: '16vw', paddingRight: '0.5vw' }}
                options={state.templateList}
                value={!state.disableInputs ? state.selectedName : null}
                getOptionLabel={(option) => typeof option === 'string' ? option : option?.template_name}
                onChange={(e, value) => {
                    updateState({
                        selectedName: value?.template_name,
                        selectTemplate: value,
                        certificateTxt: value.description,
                        renameTxt: value.description,
                        edittempName: true,
                    });
                }}
                renderOption={(props, option) => (
                    <li {...props} style={{ padding: '0vh 1.5vh' }}>
                        <ListItem>
                            <ListItemText primary={ContentInTooltip(option.template_name, 13)} />
                        </ListItem>
                    </li>
                )}
                renderInput={(params) => <TextField {...params} label="Select Template Name" />}
                PaperComponent={({ children }) => (
                    <Paper sx={{ maxHeight: '25vw', overflow: 'auto' }}>
                        {children}
                        <Divider />
                        {state?.edittempName === false &&
                            <TemplateActionButton
                                label="Save As Template"
                                onClick={() => {
                                updateState({ triggerTemplateValidation: true });
                                toolsRef.current?.sendSavedData();
                                }}
                            />}
                        {state?.edittempName && (
                            <><TemplateActionButton
                                label="Rename"
                                onClick={() =>
                                    updateState({
                                        isTempAdd: true,
                                        addLayoutName: state.selectTemplate?.template_name || "",
                                        selectedID: state.selectTemplate?.id,
                                    })
                                }
                            />
                                <TemplateActionButton
                                    label="Delete"
                                    onClick={() => {
                                        updateState({
                                            deleteTemp: true,
                                            selecDelID: state.selectTemplate?.id
                                        });
                                    }}
                                />
                            </>
                        )}
                    </Paper>
                )}
            />)
    }

    const clearEditor = () => {
        updateState({
            certificateTxt: "",
        })
    }

    const handleSave = (value) => {
        try {
            const clinic_id = localGetItem("SelectedDoctorClinicId")
            const data = {
                "clinic_id": clinic_id,
                "appointment_id": state.patientDetails?.appointment_id,
                "description": value
            }
            LoaderFunction(true);
            RestAPIService.create(data, Serviceurls.CUSTOM_CERTIFICATE_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        getCertificateTxt()
                        successMessage(response?.data?.message)
                        LoaderFunction(false);
                    }
                }).catch((error) => {
                    LoaderFunction(false);
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (e) {
            errorMessage(e?.message)
        }
    }

    const Validation = (textEditorValue) => {
        if (CommonValidation.removeSpace(textEditorValue) !== "") {
            updateState({ certificateTxt: textEditorValue || "" })
            handleSave(textEditorValue || "")
        } else {
            errorMessage(`Enter Custom Certificate Content`)
        }
    }

    const handleOnChange = (textEditorValue) => {
        const value = textEditorValue || "";

        if (state.triggerTemplateValidation) {

            if (CommonValidation.removeSpace(value) !== "") {
                updateState({
                    certificateTxt: value,
                    isTempAdd: true,
                    triggerTemplateValidation: false
                });
            } else {
                errorMessage(`Enter Custom Certificate Content`);
                updateState({
                    triggerTemplateValidation: false
                });
            }

        } else {
            updateState({ certificateTxt: value });
        }
    }

    return (
        <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'73vh'} p={'0.5vw'}>
            <Box component={'div'} display={'flex'} justifyContent={"space-between"} alignItems={'center'} mb={'0.5vw'}>
                <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
                    <CommonPatientDetails data={state.patientDetails} showDetailed={true} fromDoctor={true} />
                </Box>
                <Box display="flex" alignItems={"center"} gap={"0.625vw"}>
                    <Button className='eMed_usrconf_btn' size="small"
                        onClick={handlePrint}>
                        <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                    </Button>
                    {renderTemplateDropdown()}
                </Box>
            </Box>
            <ToolsFieldWithMic
                key={state.certificateTxt}
                ref={toolsRef}
                Title={""}
                EditorRef={state.certificateTxt || ""}
                EditorDisable={false}
                minHeight={"45vh"}
                EditorHeight={"45vh"}
                overallHeight={"61.5vh"}
                clearEditorText={clearEditor}
                isFrom="DocCustomCertificate"
                saveData={handleOnChange.bind(this)}
                handlePost={Validation.bind(this)}
                disableSave={state.disableInputs || getCachevalue('DoctorUserChanged') === 'true'}
                errorMsg={errorMessage.bind(this)}
                maxChar={10000}
            />
            <div>
                {state.isErrorMsg &&
                    <ToastMsg
                        severity={'error'}
                        msg={state.isErrorMsgText}
                        msgPop={msgClose.bind(this)}
                    />}

                {state.successMsg &&
                    <ToastMsg
                        severity={'success'}
                        msg={state.successMsgText}
                        msgPop={msgClose.bind(this)}
                    />}
            </div>
            <Loader loaderOpen={state.isLoader} />
            {state.isTempAdd && renderLayAdd()}
            {state.deleteTemp && <ConfirmPopup
                cnfTitle={props.t('Confirmation')}
                cnfContent={props.t('Are you sure, Do you want Delete the Template')}
                cnfAlertPopupClose={popClose.bind(this)}
                cnfData={deleteTempData.bind(this)}
            />}
        </Box>
    )
}

export default withTranslation()(DocCustomCertificate);